import Vue from "vue";

const state = {
  survey: false,
  id: "O8R4M1PnBbL23FO6oAZq"
};

const actions = {
  getSurvey({state, commit, dispatch}){
    dispatch("getDoc", {
      doc: `surveys/${state.id}`
    }, {root: true} ).then( data => {
      commit("SET_SURVEY", data )
    }).catch(( ) => {
    })
  }, 
};

const mutations = {
  SET_SURVEY(state, survey){
    Vue.set(state, "survey", survey)
  }
};


export default {
  namespaced: true,
  state,
  actions,
  mutations,
};

